export default __webpack_public_path__ + "static/media/HandLetteredMenu.247c53fb.jpg";